/// <amd-module name="Test/AttachmentsView/TelemetryConstants" />
export const featureTestTab_PreviewTestAttachment: string = "TestTab_PreviewTestAttachment";
export const featureTestTab_AttachmentDownloadedCount: string = "NewTestTab_AttachmentDownloadedCount";
export const featureTestTab_AttachmentsExtensionType: string = "NewTestTab_AttachmentsExtensionType";
export const featureTestTab_AttachmentsCount: string = "NewTestTab_AttachmentsCount";
export const featureTestTab_PerfLogStoreAttachment: string = "TestTab_PerfLogStoreAttachment";
export const TestTab_LogStoreAttachmentAreaName: string = "TestTab_LogStoreAttachment";
